









































export default
    data: ->
        show: true
    created: ->
        this.show = !localStorage.getItem 'cookies'
    methods:
        hide: ->
            localStorage.setItem 'cookies', true
            this.show = false

